import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'a-message',
    templateUrl: './a-message.component.html',
    styleUrls: ['./a-message.component.scss'],
    standalone: false
})
export class AMessageComponent implements OnInit {

    @Input()
    public position: string = '';

    constructor() {
    }

    ngOnInit(): void {
    }

}
